const responseConstants = {
  SUCCESS: 'Success',
};
export default responseConstants;
